// extracted by mini-css-extract-plugin
module.exports = {"submenu":"submenu___2-J6g","is-open":"is-open___3Uzzv","group":"group___1J4gL"};